import { createSelector } from '@ngrx/store';

import { selectCheckRequirementsState } from '../../../core.state';
import { selectCountryCards } from '../../country-card/store/country-card.selectors';
import { getUsers } from '../../user/store/user.selectors';

export const selectCheckRequirementsForm = createSelector(
    selectCheckRequirementsState,
    (checkRequirements) => checkRequirements.form
);

export const selectCheckRequirementsUserId = createSelector(
    selectCheckRequirementsForm,
    (form) => form.value.userId
);

export const selectCheckRequirementsPeriodFrom = createSelector(
    selectCheckRequirementsForm,
    (form) => form.value.from
);

export const selectCheckRequirementsPeriodTo = createSelector(
    selectCheckRequirementsForm,
    (form) => form.value.to
);

export const selectCheckRequirementsSelectedUser = createSelector(
    selectCheckRequirementsUserId,
    getUsers,
    (userId, users) => userId ? users.find(u => u.id === userId) : null
);

export const selectCheckRequirementsValidDocuments = createSelector(
    selectCheckRequirementsState,
    (checkRequirements) => checkRequirements.validDocuments
);

export const selectCheckRequirementsValidDocumentsLoaded = createSelector(
    selectCheckRequirementsState,
    (checkRequirements) => checkRequirements.validDocumentsLoaded
);

export const selectCheckRequirementsShowPopup = createSelector(
    selectCheckRequirementsState,
    (state) => state.showPopup
);

export const selectCheckRequirementsCountryId = createSelector(
    selectCheckRequirementsForm,
    (form) => form.value.countryId
);

export const selectCheckRequirementsCountryCard = createSelector(
    selectCountryCards,
    selectCheckRequirementsCountryId,
    (countriesCards, countryId) => (countryId && countriesCards) ? countriesCards.find(cc => countryId === cc.countryId) : null
);

export const selectCheckRequirementsCountryCardCertifications = createSelector(
    selectCheckRequirementsCountryCard,
    (countryCard) => countryCard?.certificationTypes
);

export const selectCheckRequirementsCountryCardPublicHealthRecordTypes = createSelector(
    selectCheckRequirementsCountryCard,
    (countryCard) => countryCard?.compulsoryPublicHealthRecordTypes
);
